(function(){
    'use strict';

    angular
    .module('app')
    .controller('ContactoController', ContactoController)
    .constant("prefixCampos", "_campo_");
 
    ContactoController.$inject = ['ContactoService',"$http","$timeout","$uibModal", "$log", "$document","$sce",'prefixCampos'];
              
    function ContactoController(ContactoService,$http,$timeout,$uibModal, $log, $document,$sce,prefixCampos)
    {                         
        var vm = this; 
        vm.prefixCampos = prefixCampos; 
        vm.loading = true;
        vm.responder = {};
        vm.reenviar = {};
        vm.content_id = {};
        vm.usuarios = [];
        vm.historial = [];
        vm.tipo = "";
        vm.responder.mailto = "";
        vm.responder.asunto = "";
        vm.responder.contacto = "";
        vm.reenviar.mailto = "";
        vm.reenviar.asunto = "";
        vm.reenviar.contacto = "";

        vm.modalMsg = "";
        vm.init = function(id,tipo){
            vm.content_id = id;
            vm.tipo = tipo;
            ContactoService.getContacto(vm,function(data){
                vm.usuarios = data.usuarios;
                vm.historial = data.historial;
                vm.responder.mailto = data.mailto;
                vm.responder.asunto = data.asunto;
                vm.reenviar.contacto = data.mensajeReenviar;
                vm.reenviar.asunto = data.reasunto;
                vm.loading = false;
            });
        }

        vm.enviarResponder = function(){
            vm.loading = true;
            ContactoService.sendResponder(vm,function(data){
                if(data.code==1){
                    vm.historial.unshift(data.historial);
                }
                //vm.responder.asunto = "";
                vm.responder.mensaje = "";
                vm.loading = false;
                vm.modalMsg = $uibModal.open({
                  animation: true,
                  windowClass : (data.code==-1 ? 'modal-danger' : 'modal-success'),
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'msg.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.code = data.code;
                    $scope.error = data.error;
                    $scope.okForm = function(){
                        vm.modalMsg.close();
                    }
                  }
              });



            });
        }

        vm.enviarReenviar = function(){
            vm.loading = true;
            ContactoService.sendReenviar(vm,function(data){
                if(data.code==1){
                 vm.historial.unshift(data.historial);
                }
                //vm.responder.asunto = "";
                vm.reenviar.mensaje = "";
                vm.loading = false;
                vm.modalMsg = $uibModal.open({
                  animation: true,
                  windowClass : (data.code==-1 ? 'modal-danger' : 'modal-success'),
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'msg.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.code = data.code;
                    $scope.error = data.error;
                    $scope.okForm = function(){
                        vm.modalMsg.close();
                    }
                  }
                });
            });
        }

        vm.saveContenido = function(){
            
        }
    } 
  
})();